// @ts-strict-ignore
import { inject, singleton } from "tsyringe";
import { Consents } from "./types";
import { SENTRY } from "@identity/symbols";
import { SentryLoader } from "../../sentry-loader";
type AsyncCommand = () => Promise<void>;
type Command = () => void;

@singleton()
export class ConsentResolver {
  private consentGiven: boolean;

  constructor(@inject(SENTRY) private readonly sentry: SentryLoader) {}

  public resolve(
    consents: Consents,
    onConfirm: AsyncCommand,
    onReject: Command,
  ): void {
    if (
      (consents.geoRequiresConsent && consents.gdprConsent) ||
      (consents.geoRequiresSignal && !consents.ccpaSignal) ||
      (!consents.geoRequiresSignal && !consents.geoRequiresConsent)
    ) {
      this.consentGiven = true;
      // optional for unit tests
      onConfirm()?.catch((error) => this.sentry.captureException(error));
    } else if (
      (consents.geoRequiresSignal && consents.ccpaSignal) ||
      (consents.geoRequiresConsent && !consents.gdprConsent)
    ) {
      this.consentGiven = false;
      onReject();
    }
  }

  getConsents(): boolean {
    return this.consentGiven;
  }
}
